import { useEffect, useState } from "react";
import { api, dt } from "@/lib/api";
import { PageHeader, Card, Table } from "@/components/common";

export default function AuditLog() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => { const t = setTimeout(() => api.get("/audit", { params: q ? { q } : {} }).then((r) => setRows(r.data)), 250); return () => clearTimeout(t); }, [q]);
  return (
    <div>
      <PageHeader title="Audit log" sub="Semua aksi penting tercatat dan tidak dapat diubah.">
        <input className="inp !w-64" placeholder="Cari kode / detail…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search-input" />
      </PageHeader>
      <Card>
        <Table testid="audit-table" rows={rows} cols={[
          { h: "Waktu", r: (a) => <span className="num text-xs">{dt(a.ts)}</span> }, { h: "Pengguna", r: (a) => <b>{a.user?.name}</b> },
          { h: "Aksi", r: (a) => <span className="num text-xs">{a.action}</span> }, { h: "Entitas", k: "entity_type" },
          { h: "Ref", r: (a) => <span className="num text-xs font-semibold">{a.entity_code}</span> }, { h: "Detail", k: "detail", cls: "!whitespace-normal min-w-[320px]" },
        ]} />
      </Card>
    </div>
  );
}
